import { getMostlyAppropiateLangCode } from './get-mostly-appropiate-default-lang-code'
import { getBrowserLanguage } from './get-browser-language'
import { get, put } from './inner-store'

import type { iI18nConfig, iI18nConfigApi } from './types'

export type iI18n = (config: iI18nConfig) => Promise<iI18nConfigApi>
const init: iI18n = async ({
  requestLang,
  availableLanguages,
  initialLanguage = null,
  store = {
    get: () => null,
    put: (): void => {},
  },
  fetchLanguage = true,
}) => {
  const storedLangCode = await store.get()

  const langCode = getMostlyAppropiateLangCode(
    storedLangCode || initialLanguage || getBrowserLanguage(),
    availableLanguages,
  )

  await store.put(langCode)

  if (fetchLanguage) {
    const language = await requestLang(langCode)
    put('language', language)
  }

  put('requestLang', requestLang)
  put('availableLanguages', availableLanguages)
  put('store', store)
  put('langCode', langCode)
  put('initialLanguage', initialLanguage)

  return {
    langCode: () => get('langCode'),
    language: () => get('language'),
  }
}

export { init }
